window.global = {};
